var Animations = {};


//--------------
// Functions
//--------------

/**
 * Resize function
 * @return {void}
 */
Animations.onResize = function() {
	if($(window).width() > 991) {
		console.log('> 991');

		$(".main-wrapper").animsition({
		    inClass: 'fade-in',
		    outClass: 'fade-out',
		    inDuration: 1200,
		    outDuration: 800,
		    linkElement: 'a:not([target="_blank"]):not([href^="#"])',
		    // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
		    loading: false,
		    loadingParentElement: 'body', //animsition wrapper element
		    loadingClass: 'animsition-loading',
		    loadingInner: '', // e.g '<img src="loading.svg" />'
		    timeout: false,
		    timeoutCountdown: 5000,
		    onLoadEvent: true,
		    browser: [ 'animation-duration', '-webkit-animation-duration'],
		    // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
		    // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
		    overlay : false,
		    overlayClass : 'animsition-overlay-slide',
		    overlayParentElement : 'body',
		    transition: function(url){ window.location.href = url; }  
		});

		$('.main-wrapper').on('animsition.inStart', function(){
			$('.loader').hide();
			$(this).addClass('is-init');
		})
		$('.main-wrapper').on('animsition.outStart', function(){ $('.loader').show(); })

		setTimeout(function(){
			if(!$('.main-wrapper').hasClass('is-init')) {
				$('.main-wrapper').addClass('initialization');
			}
		}, 3000);


		// Master Banner Line
		if($('.banner-master').length > 0) {
			var scene1 = new ScrollMagic.Scene({triggerElement: ".banner-master"})
				// trigger animation by adding a css class
				.setClassToggle(".banner-master", "is-animated")
				// .addIndicators({name: "1 - add a class"}) // add indicators (requires plugin)
				.addTo(controller);
		}

		// Home Prestations Title Line
		if($('#home-prestations').length > 0) {
			var scen2 = new ScrollMagic.Scene({triggerElement: "#home-prestations"})
				// trigger animation by adding a css class
				.setClassToggle("#home-prestations .js-title-line", "is-animated")
				// .addIndicators({name: "1 - add a class"}) // add indicators (requires plugin)
				.addTo(controller);
		}
	}

	if($(window).width() > 767) {
		console.log('> 767');
		
		// Banner Line
		if($('.js-banner-line').length > 0) {
			var scene3 = new ScrollMagic.Scene({triggerElement: ".js-banner-line"})
				// trigger animation by adding a css class
				.setClassToggle(".js-banner-line", "is-animated")
				// .addIndicators({name: "1 - add a class"}) // add indicators (requires plugin)
				.addTo(controller);
		}

		// Page Title Line
		if($('.js-page-title-line').length > 0) {
			var scene3 = new ScrollMagic.Scene({triggerElement: ".js-page-title-line"})
				// trigger animation by adding a css class
				.setClassToggle(".js-page-title-line", "is-animated")
				// .addIndicators({name: "1 - add a class"}) // add indicators (requires plugin)
				.addTo(controller);
		}

		// Cat Filter Line
		if($('.js-cat-filter').length > 0) {
			var scene3 = new ScrollMagic.Scene({triggerElement: ".js-cat-filter"})
				// trigger animation by adding a css class
				.setClassToggle(".js-cat-filter", "is-animated")
				// .addIndicators({name: "1 - add a class"}) // add indicators (requires plugin)
				.addTo(controller);
		}
	}
}

//--------------
// Execution
//--------------

// init controller
var controller = new ScrollMagic.Controller();


$(window).on('resize', function(){
 	Animations.onResize();
});

Animations.onResize();


// Init Contact Map
// Animations.initMap();

module.exports = Animations;